import client from '../config/AxiosConfig';

export const GetFlowersForCoupleToSelect = async (weddingId, section) =>
  client.get(`/orderFlowers/couple/${weddingId}/select/${section}`);